import React from 'react';

export const DropboxSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M20.0194 12.2907L12.5097 17.0814L20.0194 21.872L12.5097 26.6627L5 21.8461L12.5097 17.0555L5 12.2907L12.5097 7.5L20.0194 12.2907ZM12.4709 28.2035L19.9806 23.4128L27.4903 28.2035L19.9806 32.9942L12.4709 28.2035ZM20.0194 21.8461L27.5291 17.0555L20.0194 12.2907L27.4903 7.5L35 12.2907L27.4903 17.0814L35 21.872L27.4903 26.6627L20.0194 21.8461Z"
			fill="#0061FF"
		/>
	</svg>
);
